"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawRightDirection(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 630.612 532.5",
    style: styleProps
  }, props), React.createElement("path", {
    fill: "#ffb8b8",
    d: "M93.512 510.086l12.234 3.42 19.016-45.562-18.056-5.048-13.194 47.19z"
  }), React.createElement("path", {
    d: "M126.165 531.464l-38.45-10.75 4.153-14.857 25.082 7.013a13.882 13.882 0 019.631 17.107l-.416 1.487z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#ffb8b8",
    d: "M239.451 519.667l12.704-.001 6.041-49-18.749.001.004 49z"
  }), React.createElement("path", {
    d: "M276.656 531.46l-39.926.004-.001-15.426 26.044-.003a13.882 13.882 0 0113.883 13.881v1.544z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#b3b3b3",
    d: "M145.049 316.237l-29.24 71.631 119.397 26.823 1.523-40.076-54.216-57.747-37.464-.631z"
  }), React.createElement("circle", {
    cx: 481.432,
    cy: 364.452,
    r: 27.293,
    transform: "rotate(-28.663 -20.526 829.743)",
    fill: "#ffb8b8"
  }), React.createElement("path", {
    d: "M216.24 312.273l-54.044-22.123-4.812-31.727a36.456 36.456 0 0128.898-41.256l7.148-1.436a36.791 36.791 0 0132.947 9.772 35.127 35.127 0 0110.307 31.605 30.6 30.6 0 01-5.781 13.47c-16.978 22.202-14.799 40.658-14.775 40.842z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M238.245 395.015l-27.084-43.075 8.53-78.354-11.784-58.601.627.015a26.704 26.704 0 0126.037 26.049l11.464 57.424z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M238.864 510.404a4.946 4.946 0 01-4.844-3.97l-11.866-59.005a92.563 92.563 0 00-12.051-30.522l-33.482-54.161a1.722 1.722 0 00-3.055.244l-55.047 132.237a4.956 4.956 0 01-5.553 2.944l-14.706-2.998a4.924 4.924 0 01-3.887-5.671l11.996-70.698a182.474 182.474 0 0112.42-41.89l40.626-93.893 59.955 19.69 3.957 41.983 27.702 67.078a45.982 45.982 0 013.388 14.549l5.117 77.525a4.968 4.968 0 01-4.53 5.254l-15.733 1.287a5.17 5.17 0 01-.407.017z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M129.491 414.225l-19.007-18.042 35.921-138.517a58.06 58.06 0 0134.165-39.031l.705-.287-1.92 84.304zM190.378 207.897c-6.743-5.836-8.793-16.724-4.662-24.75s14.01-12.348 22.458-9.823c7.956 2.378 17-5.554 16.03-14.059s-11.548-14.045-18.751-9.82a30.51 30.51 0 00-32.524 6.335c-8.463 8.29-11.674 21.844-7.875 33.241s14.405 20.026 25.324 18.876z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M166.503 429.714a4.663 4.663 0 01-1.034.266l-43.394 6.058a4.67 4.67 0 01-5.027-2.963L79.695 335.88a4.69 4.69 0 013.356-6.26l40.809-9.107a3.728 3.728 0 00.906-.332l39.692-20.752a4.646 4.646 0 01.965-.375l43.68-11.645a4.681 4.681 0 015.587 2.849l32.57 84.748a4.667 4.667 0 01-.617 4.484l-11.263 15.126a4.684 4.684 0 01-2.08 1.576l-24.616 9.46a3.708 3.708 0 00-.511.244l-41.02 23.508a4.685 4.685 0 01-.65.31z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M186.692 300.365l-5.547 1.48-14.7 3.92-.025.006-20.125 10.523-7.469 3.906-.003.001-11.217 5.864-.308.07-11.652 2.598-5.632 1.26-22.97 5.125 36.06 93.828 23.67-3.303 5.803-.811 12.37-1.729.144-.018 39.75-22.782 24.184-9.295 11.042-14.827-31.389-81.676z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M94.27 353.917l119.58-45.956 2.048 5.33-119.58 45.955zM101.095 371.679l119.58-45.956 2.049 5.33-119.58 45.955zM114.884 407.558l119.58-45.956 2.049 5.33-119.58 45.955z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M186.692 300.365l35.8 93.154-5.328 2.048-36.019-93.722 5.547-1.48zM146.295 316.294l-7.351 20.454-2.549 7.095-5.946 16.555-1.274 3.539-1.275 3.556-1.679 4.669L114.17 405.7l-3.133-8.153 9.826-27.349 2.223-6.192.326-.904 2.629-7.321 3.317-9.233 2.549-7.096 6.916-19.251.003-.001 7.469-3.906z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M205.707 399.97l-.867.333-39.749 22.782-.144.018-37.649-96.969.308-.069 11.217-5.864.003-.001 7.469-3.906 20.125-10.523.026-.006 39.261 94.205z"
  }), React.createElement("path", {
    d: "M166.682 430.18a5.18 5.18 0 01-1.143.295l-43.395 6.058a5.168 5.168 0 01-5.563-3.279L79.228 336.06a5.19 5.19 0 013.714-6.928l40.809-9.106a3.243 3.243 0 00.783-.287l39.692-20.752a5.16 5.16 0 011.067-.416l43.682-11.645a5.18 5.18 0 016.182 3.153l32.57 84.749a5.165 5.165 0 01-.683 4.962l-11.263 15.125a5.183 5.183 0 01-2.301 1.745l-24.616 9.46a3.211 3.211 0 00-.443.21l-41.019 23.51a5.19 5.19 0 01-.72.341zm-83.754-98.96a3.19 3.19 0 00-1.833 4.122l37.353 97.195a3.177 3.177 0 003.42 2.015l43.394-6.058a3.204 3.204 0 001.146-.391l41.019-23.51a5.208 5.208 0 01.719-.34l24.616-9.461a3.188 3.188 0 001.415-1.072l11.263-15.126a3.175 3.175 0 00.42-3.05l-32.57-84.748a3.184 3.184 0 00-3.8-1.939l-43.681 11.646a3.29 3.29 0 00-.656.255l-39.692 20.753a5.276 5.276 0 01-1.274.466l-40.809 9.106a3.165 3.165 0 00-.45.136z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M115.646 328.733l36.931 96.099-5.803.811-36.76-95.651 5.632-1.259z"
  }), React.createElement("circle", {
    cx: 126.268,
    cy: 364.859,
    r: 2.664,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 220.723,
    cy: 367.698,
    r: 2.664,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M221.802 319.583c3.023 7.867-.615 33.939-1.895 42.308a1.521 1.521 0 01-2.467.948c-6.555-5.358-26.718-22.283-29.741-30.15a18.267 18.267 0 1134.103-13.107z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 204.75,
    cy: 326.135,
    r: 9.895,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M192.04 304.785a10.42 10.42 0 0114.516-6.676l17.664-15.968 12.321 8.368-25.261 22.199a10.476 10.476 0 01-19.24-7.923z",
    fill: "#ffb8b8"
  }), React.createElement("path", {
    d: "M220.502 309.997l-13.847-18.79 31.567-20.204-22.625-32.284a13.082 13.082 0 0119.53-17.172l28.33 25.847a23.73 23.73 0 01-3.33 37.597z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M112.02 359.3a10.42 10.42 0 001.447-15.911l9.153-21.982-12.001-8.82-12.49 31.224a10.476 10.476 0 0013.892 15.49z",
    fill: "#ffb8b8"
  }), React.createElement("path", {
    d: "M118.205 336.981l-21.646-5.04 16.13-46.516a76.263 76.263 0 0112.134-22.205l26.316-33.465a14.716 14.716 0 0123.2 18.11l-29.2 37.688z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M382 532.5H1a1 1 0 110-2h381a1 1 0 010 2z",
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M529.787 532h-9V4.5a4.5 4.5 0 019 0z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M595 532.5H455a1 1 0 010-2h140a1 1 0 010 2z",
    fill: "#ccc"
  }), React.createElement("path", {
    d: "M592.237 69h-130.95a4.505 4.505 0 01-4.5-4.5v-38a4.505 4.505 0 014.5-4.5h130.96a4.51 4.51 0 012.193.57l33.865 18.9a4.5 4.5 0 01.017 7.849l-33.874 19.1a4.513 4.513 0 01-2.21.581z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M580.287 151h-130.95a4.511 4.511 0 01-2.21-.58l-33.874-19.101a4.5 4.5 0 01.017-7.85l33.865-18.898a4.51 4.51 0 012.193-.571h130.96a4.505 4.505 0 014.5 4.5v38a4.505 4.505 0 01-4.5 4.5zM580.787 231.5h-130.95a4.511 4.511 0 01-2.21-.58l-33.874-19.101a4.5 4.5 0 01.017-7.85l33.865-18.898a4.51 4.51 0 012.193-.571h130.96a4.505 4.505 0 014.5 4.5v38a4.505 4.505 0 01-4.5 4.5z",
    fill: "#e6e6e6"
  }));
}
exports.default = UndrawRightDirection;